import {characterMap, regexp} from './transliteration.cyr';

const DOMAIN = (typeof window !== 'undefined') ?
  window.location.hostname.split('.').splice(-2).join('.') :
  'zolotoykod.ru';

const COOKIE_DOMAIN = `.${DOMAIN}`;
const COOKIE_PATH = '/';

const titlePostfix = ' - Золотой Код';
let descriptionPostfix = 'Интернет магазин торгового оборудования. Купить торговое оборудование и программы';
    descriptionPostfix += ' для магазинов и ресторанов - Магазин ИТ услуг. Наш телефон: 8-800-775-73-99 - Золотой код';

export let getTitle = (title: string) => title + titlePostfix;

export let getDescription = (title: string) => descriptionPostfix;

// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
let idCounter = 0;
const uniqueId = (prefix: string): string => {
  const id = ++idCounter + '';
  return prefix ? prefix + id : id;
};

const isPlainObject = (obj: any): boolean => {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

const isUndefined = (obj: any): boolean => {
  return obj === void 0;
};

/**
 * Transliterates Russian and Ukrainian words from cyrillic to latin.
 *
 * @param str {String} word
 * @return {String} transliterated word
 * @api public
 */
const transliterate = (str: string): string => {
  if (str && str.toString) str = str.toString();
  if (!str.length) return '';
  const rtn = [];
  // applying зг-zgh rule
  str = str.replace(regexp.Zgh, 'Zgh');
  str = str.replace(regexp.zgh, 'zgh');
  // replace characters with equivalent maps
  for (let i = 0; i < str.length; i++) {
    const character = str[i];
    const latinCharacter = characterMap[character];
    rtn.push((latinCharacter || latinCharacter === '') ? latinCharacter : character);
  }
  return rtn.join('');
};

export const parseQuery = (url: string): any => {
  const qstr = url.split('?')[1] || '';
  const query = {};
  const a = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('&');
  for (let i = 0; i < a.length; i += 1) {
    const b = a[i].split('=');
    if (!b[0]) continue;
    query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
  }
  return query;
};

export const setQueryParams = (url: string, _params: object): string => {
  const params = Object.assign({}, parseQuery(url), _params);

  return Object.keys(params)
    .map((k) => ({ key: k, value: params[k] }))
    .reduce(
      (query, item) => {
        if (!item.value) return query;
        return query +
          (query.includes('?') ? '&' : '?') +
          `${item.key}=${(typeof item.value === 'string') ? item.value : JSON.stringify(item.value)}`;
      },
      url,
    );
};

/* export const viewportMinWidth = () => {
  const viewport = document.querySelector('meta[name=viewport]');
  if (viewport) {
    const minWidth = 680;
    if (screen.width < minWidth) {
      const newViewport = document.createElement('meta');
      newViewport.setAttribute('name', 'viewport');
      newViewport.setAttribute('content', 'width=' + minWidth);
      document.head.removeChild(viewport);
      document.head.appendChild(newViewport);
    }
  }
}; */

export const PHONE_MASK = ['+', '7', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

export {
  DOMAIN,
  COOKIE_DOMAIN,
  COOKIE_PATH,
  uniqueId,
  transliterate,
  isUndefined,
  isPlainObject,
};
